import formFloatingLabels from './floatingForms';
import formMatrixValidation from './formMatrixValidation';
import steppedSelectOption from './steppedSelectOption';

document.addEventListener('DOMContentLoaded', formFloatingLabels);
document.addEventListener('DOMContentLoaded', formMatrixValidation);
document.addEventListener('DOMContentLoaded', steppedSelectOption);
